import ProvisionalReceiptFilter from './ProvisionalReceiptFilter';

export default ProvisionalReceiptFilter;
